export default __webpack_public_path__ + "static/media/main_press_room.f30344da.png";